// Shared pieces of the homecoming plan: ticks (synced) and a checklist row.

import { Check, ChevronRight } from 'lucide-react';
import type { PlanItem } from '../../content/homecoming.ts';
import { currentPerson } from '../../data/actions.ts';
import { useCollection, useHousehold } from '../../data/hooks.ts';
import { data } from '../../data/index.ts';
import { navigate } from '../../app/router.ts';
import { Avatar } from '../../ui/bits.tsx';

export function toggleTick(id: string, done: boolean): void {
  data().store.put('homecoming', { id, done, by: currentPerson(), at: Date.now() });
}

export function useTicks(): Map<string, { done: boolean; by?: string }> {
  const ticks = useCollection('homecoming');
  return new Map(ticks.map((t) => [t.id, t]));
}

export function PlanRow({ item, done, by }: { item: PlanItem; done: boolean; by?: string }) {
  const h = useHousehold();
  const person = h.people.find((p) => p.id === by);
  return (
    <li className={`plan-row${done ? ' done' : ''}`}>
      <button type="button" className="plan-tick" role="checkbox" aria-checked={done} onClick={() => toggleTick(item.id, !done)} aria-label={item.text}>
        <Check aria-hidden />
      </button>
      <div className="plan-text">
        <span className="plan-title">{item.text}</span>
        {item.detail && <span className="muted small">{item.detail}</span>}
      </div>
      {done && person && <Avatar person={person} size={24} />}
      {item.route && (
        <button type="button" className="icon-btn plan-more no-print" onClick={() => navigate(item.route!)} aria-label="More">
          <ChevronRight aria-hidden />
        </button>
      )}
    </li>
  );
}

